const { Component } = require('react')
const PropTypes = require('prop-types')

class Check extends Component {
  static get propTypes () {
    return {
      checked: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      checked: false
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      checked: props.checked
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.hasOwnProperty('checked') && (this.state.checked !== nextProps.checked)) {
      this.setState({ checked: nextProps.checked })
    }
  }

  get className () {
    const classList = ['check']

    if (this.state.checked) {
      classList.push('checked')
    }

    return classList.join(' ')
  }

  render () {
    return (<div className={this.className} />)
  }
}

module.exports = Check
